import type { OrderStatus } from "@mydailydirect/api-client";

type BadgeVariant = "default" | "secondary" | "success" | "warning" | "destructive" | "outline";

const META: Record<OrderStatus, { label: string; variant: BadgeVariant }> = {
  PLACED: { label: "Placed", variant: "default" },
  CONFIRMED: { label: "Confirmed", variant: "default" },
  LINED: { label: "Lined", variant: "secondary" },
  LOADED: { label: "Loaded to Truck", variant: "secondary" },
  INVOICED: { label: "Invoice Generated", variant: "success" },
  DELIVERED: { label: "Delivered", variant: "success" },
  EXCEPTION: { label: "Exception", variant: "warning" },
  RETURNED: { label: "Returned", variant: "warning" },
  RTO: { label: "RTO", variant: "destructive" },
  SETTLED: { label: "Settled", variant: "success" },
  CANCELLED: { label: "Cancelled", variant: "destructive" },
};

export function orderStatusMeta(status: OrderStatus) {
  return META[status] ?? { label: status, variant: "outline" as const };
}

/** Happy-path progression shown as a timeline on the order detail page. */
export const ORDER_FLOW: OrderStatus[] = [
  "PLACED",
  "CONFIRMED",
  "LINED",
  "LOADED",
  "INVOICED",
  "DELIVERED",
  "SETTLED",
];
